import React, { useState, useEffect } from 'react'
import { Hero, Box, Columns, Container, Button } from 'react-bulma-components'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {
    StyledHeading,
    StyledHero,
    StyledContainer,
} from '../../utils/commonStyles'
import { referenceList } from './referenceList'
import { referenceList2 } from './referenceList'
import { referenceList3 } from './referenceList'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import NewButton from '../../utils/NewButton'

const StyledBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    width: calc(146px * 4);
    padding: 0;
    overflow: hidden;

    box-shadow: none;

    width: ${(props) =>
        props.imageCount === 9
            ? 'calc(146px * 3)'
            : props.imageCount === 4
            ? 'calc(146px * 2)' // Set a 2x2 grid for 4 pictures
            : 'calc(146px * 4)'};

    .gatsby-image-wrapper {
        height: 200px;
        width: 144px;
        :hover {
            cursor: pointer;
        }
        border-radius: 1rem;
        margin: 1px;
    }

    @media (max-width: 768px) {
        width: calc(144px * 4);

        .imageWrapper:nth-child(n + 7) {
            display: none;
        }
    }

    @media (max-width: 425px) {
        width: calc(146px * 2);

        .imageWrapper:nth-child(n + 7) {
            display: none;
        }
    }
`
const StyledColumn = styled(Columns.Column)`
    @media (max-width: 768px) {
        display: flex;
        justify-content: center;
    }
`

const FeatureBox = styled(Box)`
    position: absolute;
    bottom: -30px;
    right: -10px;
    border-radius: 1rem;
    padding: 1rem;
    margin: 0;
    width: 70%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
        position: absolute;
        top: 510px;
        left: 95px;
        height: 100px;
        width: 67%;
    }

    @media (max-width: 425px) {
        position: absolute;
        top: 450px;
        left: 20px;
        height: 100px;
        width: 90%;
    }

    @media (max-width: 410px) {
        position: absolute;
        top: 420px;
        left: 20px;
        height: 100px;
        width: 90%;
    }

    @media (max-width: 390px) {
        position: absolute;
        top: 400px;
        left: 20px;
        height: 100px;
        width: 90%;
    }

    @media (max-width: 375px) {
        position: absolute;
        top: 375px;
        left: 0;
        height: 100px;
        width: 100%;
    }

    @media (max-width: 355px) {
        position: absolute;
        top: 350px;
        left: 0;
        height: 100px;
        width: 100%;
    }

    @media (max-width: 320px) {
        position: absolute;
        top: 380px;
        left: 0;
        height: 100px;
        width: 100%;
    }
    h1 {
        margin-top: 0;
    }
`

const CustomStyledContainer = styled(StyledContainer)`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin-bottom: 2rem;
    gap: 1rem;

    .button {
        margin: 0.5rem;
        :focus {
            background-color: #faa735cf;
        }
        :hover:not(:focus) {
            background-color: #ffc778cf;
        }
        :active {
            background-color: #faa735cf;
        }
    }

    .gatsby-image-wrapper {
        border-radius: 1rem;
    }

    @media (max-width: 768px) {
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
    }

    @media (max-width: 425px) {
        flex-direction: column;
        .button {
            width: 75%;
        }
    }

    @media (max-width: 320px) {
        margin-bottom: 4rem;
    }
`

const TempImage = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    transition: opacity 0.5s ease-out;
    &.active {
        opacity: 1;
    }

    @media (max-width: 768px) {
        display: flex;
        justify-content: center;
    }
`

const IItem = styled.div``

export const Reference = () => {
    const stSlik = referenceList.length
    const [currentImage, setCurrentImage] = useState(
        Math.floor(Math.random() * stSlik)
    )
    const [newImage, setNewImage] = useState(0)
    const [category, setCategory] = useState(1)

    const data = useStaticQuery(graphql`
        {
            allFile(
                filter: {
                    relativeDirectory: {
                        in: [
                            "referenceGallery"
                            "referenceGallery2"
                            "referenceGallery3"
                        ]
                    }
                }
                sort: { name: ASC }
            ) {
                edges {
                    node {
                        relativeDirectory
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                formats: [AUTO, WEBP, AVIF]
                                height: 600
                                width: 432
                            )
                        }
                    }
                }
            }
        }
    `)

    const gallerySamooskrba = data.allFile.edges.filter((edge) => {
        return edge.node.relativeDirectory === 'referenceGallery'
    })

    const galleryIndustrija = data.allFile.edges.filter((edge) => {
        return edge.node.relativeDirectory === 'referenceGallery2'
    })

    const gallerySkupnost = data.allFile.edges.filter((edge) => {
        return edge.node.relativeDirectory === 'referenceGallery3'
    })

    const filteredImages =
        category === 1
            ? gallerySamooskrba
            : category === 0
            ? galleryIndustrija
            : category === 2
            ? gallerySkupnost
            : []

    const iList = filteredImages.map((edge, index) => {
        const image = getImage(edge.node)

        return (
            <IItem
                className="imageWrapper"
                key={index}
                onClick={() => {
                    setNewImage(index)
                    console.log(index)
                }}
            >
                <GatsbyImage image={image} alt={'Reference'} key={index} />
            </IItem>
        )
    })

    const mainImage = filteredImages[currentImage]
        ? getImage(filteredImages[currentImage].node)
        : getImage(filteredImages[0].node)
    const incomingImage = filteredImages[newImage]
        ? getImage(filteredImages[newImage].node)
        : getImage(filteredImages[0].node)

    const className = newImage === currentImage ? '' : 'active'

    const imageCount = filteredImages.length

    function getCategoryData(category, currentImage) {
        const data =
            category === 0
                ? referenceList2
                : category === 1
                ? referenceList
                : category === 2
                ? referenceList3
                : referenceList

        return data[currentImage] || ''
    }

    useEffect(() => {
        setTimeout(() => {
            setCurrentImage(newImage)
        }, 500)
    }, [newImage])

    const { t } = useTranslation()

    return (
        <StyledHero>
            <Hero.Body>
                <StyledHeading className={'has-text-centered'} size={1}>
                    {t('onas.references.title')}
                    <CustomStyledContainer>
                        <NewButton
                            color={'primary'}
                            onClick={() => {
                                setNewImage(0)
                                setCategory(1)
                            }}
                            style={{
                                background: category === 1 ? '#faa735cf' : '',
                            }}
                        >
                            {t('onas.references.1.name')}
                        </NewButton>
                        <NewButton
                            color={'primary'}
                            onClick={() => {
                                setNewImage(0)
                                setCategory(0)
                            }}
                            style={{
                                background: category === 0 ? '#faa735cf' : '',
                            }}
                        >
                            {t('onas.references.2.name')}
                        </NewButton>
                        <NewButton
                            color={'primary'}
                            onClick={() => {
                                setNewImage(0)
                                setCategory(2)
                            }}
                            style={{
                                background: category === 2 ? '#faa735cf' : '',
                            }}
                        >
                            {t('onas.references.3.name')}
                        </NewButton>
                    </CustomStyledContainer>
                </StyledHeading>

                <Container justifyContent="center" display="flex">
                    <Columns vCentered>
                        <Columns.Column size={'two-fifths'}>
                            <CustomStyledContainer>
                                <GatsbyImage
                                    image={mainImage}
                                    alt={'Reference'}
                                />
                                <TempImage className={className}>
                                    <GatsbyImage
                                        image={incomingImage}
                                        alt={'Reference'}
                                    />
                                </TempImage>

                                <FeatureBox>
                                    <StyledHeading size={5}>
                                        {t('onas.references.location')}:{' '}
                                        {
                                            getCategoryData(
                                                category,
                                                currentImage
                                            )[0]
                                        }
                                        <br />
                                        {t('onas.references.power')}:{' '}
                                        {
                                            getCategoryData(
                                                category,
                                                currentImage
                                            )[1]
                                        }
                                    </StyledHeading>
                                </FeatureBox>
                            </CustomStyledContainer>
                        </Columns.Column>
                        <StyledColumn size={'three-fifths'}>
                            <StyledBox imageCount={imageCount}>
                                {iList}
                            </StyledBox>
                        </StyledColumn>
                    </Columns>
                </Container>
            </Hero.Body>
        </StyledHero>
    )
}

export default Reference
